import { render } from "./BusinessModelDetailsCard.vue?vue&type=template&id=5e84a5b0&ts=true"
import script from "./BusinessModelDetailsCard.vue?vue&type=script&lang=ts"
export * from "./BusinessModelDetailsCard.vue?vue&type=script&lang=ts"

import "./BusinessModelDetailsCard.vue?vue&type=style&index=0&id=5e84a5b0&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__